import { render, staticRenderFns } from "./SupplierCatalog.vue?vue&type=template&id=2464f0dc&scoped=true&"
import script from "./SupplierCatalog.vue?vue&type=script&lang=js&"
export * from "./SupplierCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCatalog.vue?vue&type=style&index=0&id=2464f0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464f0dc",
  null
  
)

export default component.exports